import { createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  id: "app_pc",
  class: "app-inner"
};
const _hoisted_2 = {
  key: 0,
  id: "app-foot"
};
import { useRouter } from "vue-router";
import { Crisp } from "crisp-sdk-web";
import navigator from "./components_pc/common/common_nav.vue";
import foot from "./components_pc/common/common_foot.vue";

// 判断footer是否需要显示。如果页面的url来自于purchase及其子页面，则不显示footer
import { ref, onMounted, onUnmounted } from "vue";
export default {
  __name: 'App_pc',
  setup(__props) {
    const router = useRouter();
    const getCrispLocale = () => {
      const lang = String(navigator.language || "").toLowerCase();
      return lang.startsWith("zh") ? "zh" : "en";
    };
    const isShowFooter = ref(true);
    const currentPath = router.currentRoute.value.path;
    // 如果url中有purchase，则不显示footer
    if (currentPath.includes("purchase")) {
      isShowFooter.value = false;
    }
    const compactNav = ref(false);
    const handleScroll = () => {
      compactNav.value = window.scrollY > 10;
    };
    onMounted(() => {
      Crisp.configure("9bc85d1c-ef91-4a7f-a997-050eb1abcdee", {
        locale: getCrispLocale()
      });
      // 固定隐藏 Crisp（按钮及浮窗）
      window.$crisp?.push(["do", "chat:hide"]);
      handleScroll();
      window.addEventListener("scroll", handleScroll, {
        passive: true
      });
    });
    onUnmounted(() => {
      window.removeEventListener("scroll", handleScroll);
    });
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        id: "navigator",
        class: _normalizeClass(["navigator", {
          'navigator-compact': compactNav.value
        }])
      }, [_createVNode(navigator, {
        compact: compactNav.value
      }, null, 8, ["compact"])], 2), _createElementVNode("div", {
        id: "app-body",
        class: _normalizeClass(["app-body", {
          'app-body-compact': compactNav.value
        }])
      }, [_createVNode(_component_router_view), isShowFooter.value ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(foot)])) : _createCommentVNode("", true)], 2)]);
    };
  }
};